import React from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FilterOption } from '../Filter';
import * as filterActions from '../../../filterActions';
import styles from '../Filters.module.scss';

interface SelectFilterProps {
    label: string;
    options: FilterOption[];
    dynamicFilterIndex: number;
    currentValue: string;
}

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            updateDynamicFilter: filterActions.updateDynamicFilter,
        },
        dispatch,
    );

type Props = ReturnType<typeof mapDispatchToProps> & SelectFilterProps;

const SelectFilter = ({
    label,
    options,
    dynamicFilterIndex,
    updateDynamicFilter,
    currentValue = '',
}: Props) => {
    const onSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
        updateDynamicFilter(dynamicFilterIndex, event.target.value);
    };

    return (
        <div
            id={'filters-filter-select-container'}
            className={styles.filterSelectContainer}
        >
            <select
                className={styles.filterSelectControl}
                onChange={onSelect}
                value={currentValue}
            >
                <option value={''} disabled>{`Filter by ${label}...`}</option>
                {options.map(item => {
                    return (
                        <option key={item.id} value={item.value}>
                            {item.value}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default connect(null, mapDispatchToProps)(SelectFilter);
